export default "__VITE_ASSET__BZZREv8l__"